import { render, staticRenderFns } from "./NoPower.vue?vue&type=template&id=18555154&scoped=true&"
import script from "./NoPower.vue?vue&type=script&lang=js&"
export * from "./NoPower.vue?vue&type=script&lang=js&"
import style0 from "./NoPower.vue?vue&type=style&index=0&id=18555154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18555154",
  null
  
)

export default component.exports